import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import BaseDialogContainer from '../baseContainers/BaseDialogContainer';
import { ActionButton } from '../components/ActionButton';
import DivContainer from '../components/DivContainer';
import PhoneNumberComponent from '../components/PhoneNumberComponent';
import YesNoDialog from '../components/YesNoDialog';
import InputCheckboxComponent from '../components/inputs/InputCheckboxComponent';
import InputMultiCheckboxComponent from '../components/inputs/InputMultiCheckboxComponent';
import InputRadioButtonComponent from '../components/inputs/InputRadioButtonComponent';
import InputTextComponent from '../components/inputs/InputTextComponent';
import UserAgreementMapService from '../services/UserAgreementMapService';

class UserEditDialog extends BaseDialogContainer {
    constructor(props) {
        super(props, new UserAgreementMapService());
        this.state = {
            elementId: props.elementId,
            element: {
                username: '',
                firstName: '',
                lastName: '',
                phoneNumber: '',
                phoneNumberCode: undefined,
                phoneNumberValue: '',
                email: '',
                userType: 'STANDARD',
                active: true,
                permissions: [],
                twoStepAuthPhone: false,
                twoStepAuthEmail: false,
            },
            viewMode: this.props.viewMode,
            confirmationDeleteDialogVisible: false,
            accessPermissionOptions: [],
            editPermissionOptions: [],
            twoStepAuthMethod: '',
        };
        this.handleChangeEditPermission = this.handleChangeEditPermission.bind(this);
        this.handleChangeViewPermission = this.handleChangeViewPermission.bind(this);
    }

    componentDidUpdate() { }

    getContainerListName() {
        return 'settings-container';
    }

    translate(key) {
        const { t } = this.props;
        return t(key);
    }

    showConfirmationDelete() {
        this.setState({ confirmationDeleteDialogVisible: true });
    }

    hideConfirmationDelete() {
        this.setState({ confirmationDeleteDialogVisible: false });
    }

    setElement() {
        if (this.props.element) {
            this.updateElement(this.props.element);
        }
    }

    updateElement(data) {
        this.setState(
            {
                twoStepAuthMethod: data.twoStepAuthEmail ? 'EMAIL' : 'PHONE',
                element: data,
            },
            () => {
                this.initAfterSetElement();
                this.groupPermissions();
                this.splitPhoneNumber();
            }
        );
    }

    groupPermissions() {
        const sortedPermissionOptions = this.props.permissionOptions.sort((a, b) => a.permissionOrder - b.permissionOrder);

        sortedPermissionOptions.forEach(permission => {
            if (permission.permissionType.startsWith('PERMISSION_VIEW_') || permission.permissionType.startsWith('PERMISSION_FULL_ACCESS_')) {
                this.state.accessPermissionOptions.push(permission);
            } else if (permission.permissionType.startsWith('PERMISSION_EDIT_')) {
                this.state.editPermissionOptions.push(permission);
            }
        });
    };

    splitPhoneNumber() {
        const { telephoneCodeOptions } = this.props;
        const { phoneNumber } = this.state.element;
        let { phoneNumberCode, phoneNumberValue } = this.state.element;

        if (phoneNumber !== undefined && phoneNumber !== null && phoneNumber.startsWith('(')) {
            let prefix = phoneNumber.substring(0, phoneNumber.indexOf(')') + 1);
            if (prefix !== undefined) {
                telephoneCodeOptions.forEach((telephoneCodeOption) => {
                    if (prefix === telephoneCodeOption.code) {
                        phoneNumberCode = telephoneCodeOption;
                        phoneNumberValue = phoneNumber.substring(phoneNumber.indexOf(')') + 1);
                    }
                });
            }
        }

        this.setState(prevState => ({
            element: {
                ...prevState.element,
                phoneNumberCode,
                phoneNumberValue
            }
        }));
    }

    handleChangeEditPermission(inputType, parameters, event, onAfterStateChange = () => { }, stateField) {
        this.handleChange(inputType, parameters, event, () => {
            const updatedPermissions = event.checked
                ? this.selectExtraPermissionsForEdit(parameters[1])
                : this.unselectExtraPermissionsForEdit(parameters[1]);

            if (event.checked !== undefined) {
                this.setState({
                    element: {
                        ...this.state.element,
                        permissions: updatedPermissions
                    }
                }, onAfterStateChange);
            } else {
                onAfterStateChange();
            }
        }, stateField);
    }

    handleChangeViewPermission(inputType, parameters, event, onAfterStateChange = () => { }, stateField) {
        this.handleChange(inputType, parameters, event, () => {
            const updatedPermissions = event.checked
                ? this.selectExtraPermissionsForView(parameters[1])
                : this.unselectExtraPermissionsForView(parameters[1]);

            if (event.checked !== undefined) {
                this.setState({
                    element: {
                        ...this.state.element,
                        permissions: updatedPermissions
                    }
                }, onAfterStateChange);
            } else {
                onAfterStateChange();
            }
        }, stateField);
    }

    selectExtraPermissionsForEdit(editPermission) {
        let updatedPermissions = this.state.element.permissions;

        if (editPermission.permissionType.startsWith('PERMISSION_EDIT_')) {
            const correspondingViewPermission = this.state.accessPermissionOptions.find(accessPermission =>
                accessPermission.permissionType.endsWith(editPermission.permissionType.split('_EDIT_')[1])
            );
            if (correspondingViewPermission && !updatedPermissions.some(p => p.permissionType === correspondingViewPermission.permissionType)) {
                updatedPermissions.push(correspondingViewPermission);
            }
            if (editPermission.permissionType === 'PERMISSION_EDIT_FLEET_CARDS') {
                const fullAccessOrdersPermission = this.state.accessPermissionOptions.find(accessPermission =>
                    accessPermission.permissionType === 'PERMISSION_FULL_ACCESS_ORDERS'
                );
                if (fullAccessOrdersPermission && !updatedPermissions.some(p => p.permissionType === fullAccessOrdersPermission.permissionType)) {
                    updatedPermissions.push(fullAccessOrdersPermission);
                }
            }
        }
        return updatedPermissions;
    }

    unselectExtraPermissionsForEdit(editPermission) {
        let updatedPermissions = this.state.element.permissions;

        if (editPermission.permissionType === 'PERMISSION_EDIT_FLEET_CARDS') {
            const fullAccessOrdersPermission = this.state.accessPermissionOptions.find(accessPermission =>
                accessPermission.permissionType === 'PERMISSION_FULL_ACCESS_ORDERS'
            );
            if (fullAccessOrdersPermission && updatedPermissions.some(p => p.permissionType === fullAccessOrdersPermission.permissionType)) {
                updatedPermissions = updatedPermissions.filter(p => p.permissionType !== fullAccessOrdersPermission.permissionType);
            }
        }
        return updatedPermissions;
    }

    selectExtraPermissionsForView(accessPermission) {
        let updatedPermissions = this.state.element.permissions;

        if (accessPermission.permissionType === 'PERMISSION_FULL_ACCESS_ORDERS') {
            const viewFleetCardsPermission = this.state.accessPermissionOptions.find(accessPermission =>
                accessPermission.permissionType === 'PERMISSION_VIEW_FLEET_CARDS'
            );
            const editFleetCardsPermission = this.state.editPermissionOptions.find(editPermission =>
                editPermission.permissionType === 'PERMISSION_EDIT_FLEET_CARDS'
            );
            if (viewFleetCardsPermission && !updatedPermissions.some(p => p.permissionType === viewFleetCardsPermission.permissionType)) {
                updatedPermissions.push(viewFleetCardsPermission);
            }
            if (editFleetCardsPermission && !updatedPermissions.some(p => p.permissionType === editFleetCardsPermission.permissionType)) {
                updatedPermissions.push(editFleetCardsPermission);
            }
        }
        return updatedPermissions;
    }

    unselectExtraPermissionsForView(accessPermission) {
        let updatedPermissions = this.state.element.permissions;

        if (accessPermission.permissionType.startsWith('PERMISSION_VIEW_')) {
            const correspondingEditPermission = this.state.editPermissionOptions.find(editPermission =>
                editPermission.permissionType.endsWith(accessPermission.permissionType.split('_VIEW_')[1])
            );
            if (correspondingEditPermission && updatedPermissions.some(p => p.permissionType === correspondingEditPermission.permissionType)) {
                updatedPermissions = updatedPermissions.filter(p => p.permissionType !== correspondingEditPermission.permissionType);
            }
        }
        if (accessPermission.permissionType === 'PERMISSION_FULL_ACCESS_ORDERS') {
            const editFleetCardsPermission = this.state.editPermissionOptions.find(editPermission =>
                editPermission.permissionType === 'PERMISSION_EDIT_FLEET_CARDS'
            );
            if (editFleetCardsPermission && updatedPermissions.some(p => p.permissionType === editFleetCardsPermission.permissionType)) {
                updatedPermissions = updatedPermissions.filter(p => p.permissionType !== editFleetCardsPermission.permissionType);
            }
        }
        return updatedPermissions;
    }

    createOrUpdate() {
        const { t } = this.props;
        const { element } = this.state;
        if (
            element.phoneNumberCode !== undefined &&
            element.phoneNumberCode !== null &&
            element.phoneNumberValue !== undefined &&
            element.phoneNumberValue !== null &&
            element.phoneNumberValue !== ''
        ) {
            element.phoneNumber = element.phoneNumberCode.code + element.phoneNumberValue;
        } else {
            element.phoneNumber = '';
        }
        element.twoStepAuthEmail = this.state.twoStepAuthMethod === 'EMAIL' ? true : false;
        element.twoStepAuthPhone = this.state.twoStepAuthMethod === 'PHONE' ? true : false;
        this.scrollToTop();
        if (this.props._isMounted) {
            if (element.id === undefined || element.id === null) {
                this.service
                    .add(element)
                    .then(() => {
                        this.blockUi();
                        if (this.props.afterSave) {
                            this.persistMessage('success', '', t('settings.user.addUserSuccess'));
                            this.props.afterSave();
                        }
                    })
                    .catch((err) => {
                        if (this.props.afterSave && err.integrationErrorCode === 420) {
                            this.persistMessage('success', '', t('settings.user.addUserSuccess'));
                            this.props.afterSave();
                        } else if (this.props.afterError) {
                            this.persistMessage('error', '', t('error.addUserError'));
                            this.props.afterError();
                        }
                    });
            } else {
                this.service
                    .update(element)
                    .then(() => {
                        this.blockUi();
                        if (this.props.afterSaveBeforeConfirmation) {
                            this.props.afterSaveBeforeConfirmation();
                        }
                    })
                    .catch(() => {
                        if (this.props.afterError) {
                            this.persistMessage('error', '', t('error.updateUserError'));
                            this.props.afterError();
                        }
                    });
            }
        }
    }

    handleDelete(element) {
        const { t } = this.props;
        this.blockUi();
        this.service
            .delete(element)
            .then(() => {
                this.blockUi();
                if (this.props.afterSave) {
                    this.persistMessage('success', '', t('settings.user.deleteUserSuccess'));
                    this.hideConfirmationDelete();
                    this.props.afterSave();
                }
            })
            .catch(() => {
                if (this.props.afterSave) {
                    this.persistMessage('error', '', t('error.deleteUserError'));
                    this.hideConfirmationDelete();
                    this.props.afterError();
                }
            });
    }

    prepareFooter() {
        const { t } = this.props;
        return (
            <div className='footer-dialog-button-container'>
                <div className='left-footer-dialog-button-container'>
                    <ActionButton
                        label={t('details.cancel')}
                        variant={'button cancel-button white'}
                        handleClick={this.props.onHide}
                    />
                </div>
                <ActionButton
                    label={t('details.delete')}
                    variant='button remove-button fullred'
                    handleClick={() => this.showConfirmationDelete()}
                    rendered={this.state.viewMode === 'EDIT'}
                />
                <ActionButton
                    label={this.state.viewMode === 'NEW' ? t('details.addButton') : t('details.save')}
                    variant='button save-button blue'
                    handleClick={this.handleFormSubmit}
                />
            </div>
        );
    }

    renderHeader() {
        const { t } = this.props;
        return !this.state.confirmationDeleteDialogVisible && (
            <DivContainer colClass='col-12 transaction-dialog-header'>
                <DivContainer colClass='col-12'>
                    <label>
                        {this.state.viewMode === 'NEW'
                            ? `${t('settings.user.addHeader')}`
                            : this.state.viewMode === 'EDIT'
                                ? `${t('settings.user.editHeader')}`
                                : null}
                    </label>
                </DivContainer>
            </DivContainer>
        );
    }

    renderDetails() {
        const { t } = this.props;
        const cashless = this.authService.getProfile().agreementType === 'CASHLESS' ? true :  false;
        this.state.element.phoneNumberCode = (this.state.element.phoneNumberCode === undefined ?
            this.props.telephoneCodeOptions[0] : this.state.element.phoneNumberCode);
        return (
            <React.Fragment>
                <DivContainer colClass='row'>
                    <InputTextComponent
                        id='username'
                        name='username'
                        label={t('settings.user.username')}
                        colClass='col-md-6'
                        value={this.state.element.username}
                        validator={this.validator}
                        validators='not_required|max:50'
                        onChange={this.handleChange}
                        viewMode={this.state.viewMode}
                    />
                    <InputTextComponent
                        id='firstName'
                        name='firstName'
                        label={t('settings.user.firstName')}
                        colClass='col-md-6'
                        value={this.state.element.firstName}
                        validator={this.validator}
                        validators='not_required|alpha_space|max:50'
                        onChange={this.handleChange}
                        viewMode={this.state.viewMode}
                        keyfilter={/^[A-ZĄĆĘŁŃÓŚŹŻąćęłńóśźż\s]*$/i}
                    />
                </DivContainer>
                <DivContainer colClass='row'>
                    <InputTextComponent
                        id='lastName'
                        name='lastName'
                        label={t('settings.user.lastName')}
                        colClass='col-md-6'
                        value={this.state.element.lastName}
                        validator={this.validator}
                        validators='not_required|alpha_space_dash|max:50'
                        onChange={this.handleChange}
                        viewMode={this.state.viewMode}
                        keyfilter={/^[A-ZĄĆĘŁŃÓŚŹŻąćęłńóśźż\s-]*$/i}
                    />
                    <InputTextComponent
                        id='email'
                        name='email'
                        label={t('settings.user.email')}
                        colClass='col-md-6'
                        value={this.state.element.email}
                        validator={this.validator}
                        validators='required|email'
                        onChange={this.handleChange}
                        viewMode={this.state.viewMode === 'NEW' ? 'EDIT' : 'VIEW'}
                    />
                </DivContainer>
                <DivContainer colClass='row'>
                    <PhoneNumberComponent
                        id='phoneNumber'
                        nameCode='phoneNumberCode'
                        namePhoneNumber='phoneNumberValue'
                        labelCode={t('settings.user.phoneNumberCode')}
                        labelPhoneNumber={t('settings.user.phoneNumber')}
                        colClass='col-md-12'
                        phoneCodeValue={this.state.element.phoneNumberCode}
                        phoneNumberValue={this.state.element.phoneNumberValue}
                        telephoneCodeOptions={this.props.telephoneCodeOptions}
                        value={this.state.element.phoneNumber}
                        onChange={this.handleChange}
                        viewMode={this.state.viewMode}
                        validator={this.validator}
                        //renderRequired
                        required={this.state.twoStepAuthMethod === 'PHONE' ? true : false}
                    />
                </DivContainer>
                <DivContainer colClass='form-group'>
                <InputRadioButtonComponent
                                id={`two-step-auth-type`}
                                name='twoStepAuthMethod'
                                colClass='col-12 card-manage-limits'
                                options={[
                                    {enumValue: 'EMAIL', label: t('cards.twoStepAuthByEmail')},
                                    {enumValue: 'PHONE', label: t('cards.twoStepAuthByPhone')},
                                ]}
                                value={this.state.twoStepAuthMethod}
                                valueLabel='label'
                                labelOnRight
                                itemColClass={'col-xl-6 col-lg-6 col-md-6 col-sm-6'}
                                onChange={this.handleChange}
                                showLabel={true}
                                validator={this.validator}
                                validators='required'
                                label={t('cards.twoStepAuthBy')}
                                viewMode={'EDIT'}
                                //rendered={this.props.viewMode === 'EDIT'}
                                valueKey='enumValue'
                                stateField={``}
                            />
                        </DivContainer>
                <DivContainer colClass='col-12'>
                    <hr id='line-separator'
                        className='line-separator'
                    />
                </DivContainer>
                <DivContainer colClass='input-multi-checkbox-user-dialog row'>
                    <label className='label-multi-checkbox-user-dialog'>
                        {t('permissions.title')}:
                    </label>
                    <DivContainer colClass='col-multi-checkbox-user-dialog'>
                        <DivContainer colClass='form-group'>
                            <InputMultiCheckboxComponent
                                id='permissions'
                                name='permissions'
                                label={`${t('permissions.accessMode')}:`}
                                showLabel={true}
                                colClass='col-md-12'
                                value={this.state.element.permissions}
                                validator={this.validator}
                                validators='not_required'
                                onChange={this.handleChangeViewPermission}
                                viewMode={this.state.viewMode}
                                options={this.state.accessPermissionOptions}
                                valueKey='id'
                                valueLabel='label'
                                selectedItemsLabel='vvv'
                                itemColClass='col-12'
                                labelOnRight
                                stateField='element'
                            />
                        </DivContainer>
                    </DivContainer>
                    <DivContainer colClass='col-multi-checkbox-user-dialog'>
                        <DivContainer colClass="form-group">
                            <InputMultiCheckboxComponent
                                id='permissions'
                                name='permissions'
                                label={`${t('permissions.editMode')}:`}
                                showLabel={true}
                                colClass='col-md-12'
                                value={this.state.element.permissions}
                                validator={this.validator}
                                validators='not_required'
                                onChange={this.handleChangeEditPermission}
                                viewMode={this.state.viewMode}
                                options={this.state.editPermissionOptions}
                                valueKey='id'
                                valueLabel=''
                                selectedItemsLabel='vvv'
                                itemColClass='col-12'
                                labelOnRight
                                stateField='element'
                                renderAfterCheckbox={(option) => {           
                                    if ((this.state.editPermissionOptions.filter(p => p.permissionOrder === option.permissionOrder + 1).length === 0 &&
                                        Math.max(...this.state.editPermissionOptions.map(p => p.permissionOrder)) !== option.permissionOrder && cashless) || (this.state.editPermissionOptions.filter(p => p.permissionOrder === option.permissionOrder + 1).length === 0 &&
                                        Math.max(...this.state.editPermissionOptions.map(p => p.permissionOrder)) !== option.permissionOrder && option.permissionType !== 'PERMISSION_EDIT_PROFILE' && !cashless)) {
                                        return <div style={{ height: '34px' }}></div>;
                                    }
                                    else return null;
                                }}
                            />
                        </DivContainer>
                    </DivContainer>
                </DivContainer>
                {this.state.viewMode === 'EDIT' && (
                    <DivContainer colClass='col-12'>
                        <hr id='line-separator'
                            className='line-separator'
                        />
                    </DivContainer>
                )}
                {this.state.viewMode === 'EDIT' && (
                    <DivContainer colClass='row'>
                        <InputCheckboxComponent
                            id='active'
                            name='active'
                            label={t('settings.user.active')}
                            labelOnRight
                            colClass='col-width-auto'
                            value={this.state.element.active}
                            validator={this.validator}
                            validators='not_required'
                            onChange={this.handleChange}
                            viewMode={this.state.viewMode}
                        />
                    </DivContainer>
                )}
                <YesNoDialog
                    visible={this.state.confirmationDeleteDialogVisible}
                    name='confirmationDeleteDialog'
                    className='user-delete-yes-no-dialog'
                    header={t('settings.user.deleteConfirmationHeader')}
                    yesButtonLabel={t('settings.user.deleteConfirmationButton')}
                    yesButtonVariant='button save-button fullred'
                    noButtonLabel={t('details.cancel')}
                    noButtonVariant='button cancel-button white'
                    onChange={(type, x, target) => {
                        if (target.value) {
                            this.handleDelete(this.state.element);
                        } else {
                            this.hideConfirmationDelete();
                        }
                    }}
                    onHide={() => this.hideConfirmationDelete()}
                >
                    {t('settings.user.deleteConfirmationDescription')}
                </YesNoDialog>
            </React.Fragment>
        );
    }
}

UserEditDialog.defaultProps = {
    currentUser: undefined,
    viewMode: 'VIEW',
    visible: false,
    stationId: undefined,
};

UserEditDialog.propTypes = {
    backUrl: PropTypes.string,
    cancelUrl: PropTypes.string,
    currentUser: PropTypes.object,
    editUrl: PropTypes.string,
    viewMode: PropTypes.string,
    visible: PropTypes.bool,
    onHide: PropTypes.func,
    afterSave: PropTypes.func,
    afterSaveBeforeConfirmation: PropTypes.func,
    afterError: PropTypes.func,
    elementId: PropTypes.number,
    stationId: PropTypes.number,
    permissionOptions: PropTypes.array,
    telephoneCodeOptions: PropTypes.array
};

export default withTranslation()(UserEditDialog);
